import { API_V1, API_V2 } from '../api';
import { parseContent, parseDiscussionContentResponse } from '../parse';
import {
	Content,
	ContentResponse,
	DiscussionContentResponse,
	CreateDiscussionPayload,
	DiscussionContentItem,
	DiscussionMessage,
	ReplyDiscussionPayload,
	CreateDiscussionPayloadV2,
	ReplyDiscussionPayloadV2,
} from './DiscussionModel';

export enum GroupDiscussionFollowAction {
	FOLLOW = 'follow',
	UNFOLLOW = 'unfollow',
}

export enum GroupDiscussionEditAction {
	SUBJECT = 'subject',
	MESSAGE = 'message',
	REMOVE = 'remove',
	SHOW = 'show',
	CATEGORIES = 'categories',
}

export function createDiscussionV2(groupId: string, discussion: CreateDiscussionPayloadV2): Promise<DiscussionContentItem> {
	return API_V2.post(`/group/${groupId}/discussion`, discussion)
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		.then(({ data }) => data as DiscussionContentResponse)
		.then(parseDiscussionContentResponse);
}

export function replyToDiscussionV2(
	groupId: string,
	parentDiscussionId: string,
	parentVersion: number,
	discussion: ReplyDiscussionPayloadV2,
): Promise<DiscussionContentItem> {
	return API_V2.post(`/group/${groupId}/discussion/${parentDiscussionId}/${parentVersion}`, discussion)
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		.then(({ data }) => data as DiscussionContentResponse)
		.then(parseDiscussionContentResponse);
}

export function getDiscussionByIdV2(groupId: string, discussionId: string): Promise<DiscussionContentItem> {
	return API_V2.get(`/group/${groupId}/discussion/${discussionId}`)
		.then(({ data }) => data as DiscussionContentItem);
}

/**
 * @deprecated
 */
export function createDiscussion(discussion: CreateDiscussionPayload): Promise<Content> {
	return API_V1.post('/group/discussion?trackUserView=false', discussion)
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		.then(({ data }) => data as ContentResponse)
		.then(parseContent);
}

/**
 * @deprecated
 */
export function replyToDiscussion(discussion: ReplyDiscussionPayload): Promise<Content> {
	return API_V1.post(`/group/discussion/${discussion.version}?trackUserView=false`, discussion)
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		.then(({ data }) => data as ContentResponse)
		.then(parseContent);
}

export function toggleGroupDiscussionFollowStatus(messageId: string, action: GroupDiscussionFollowAction): Promise<void> {
	return API_V1.put(`/group/discussion/${messageId}/member?action=${action}`);
}

/**
 * @deprecated
 */
export function getDiscussionById(discussionId: string): Promise<Content> {
	return API_V1.get(`/group/discussion/${discussionId}?trackUserView=false`)
		.then(({ data }) => data as Content);
}

export async function markDiscussionRead(discussionId: string): Promise<void> {
	await API_V1.put(`/group/discussion/${discussionId}/read?includePast=true`);
}

export function editGroupDiscussionMessage(message: DiscussionMessage, action: GroupDiscussionEditAction): Promise<DiscussionMessage> {
	const subMessage = {
		id: message.id,
		groupId: message.groupId,
		subject: message.subject,
		categories: message.categories,
		messageText: message.messageText,
		version: message.version,
	};
	return API_V1.put(`group/discussion/${message.id}?action=${action}&trackUserView=false`, subMessage)
		// eslint-disable-next-line
		.then(({ data }) => data as DiscussionMessage);
}

export async function editGroupDiscussionCategories(message: DiscussionMessage): Promise<DiscussionMessage> {
	const subMessage = {
		id: message.id,
		groupId: message.groupId,
		subject: message.subject,
		categories: message.categories,
		messageText: message.messageText,
		version: message.version,
	};
	return API_V2.put(`group/${message.groupId}/discussion/${message.id}/categories`, subMessage)
		// eslint-disable-next-line
		.then(({ data }) => data as DiscussionMessage);
}

export const deleteContentFromDiscussion = async (groupId: string, discussionId: string, contentId: string): Promise<void> => {
	await API_V2.delete(`/group/${groupId}/discussion/${discussionId}/content/${contentId}`);
};
